<template>
  <v-container fluid grid-list-md ma-0 pa-0>
    <v-layout row wrap>
      <v-flex pa-4 xs12 sm6 md6 lg4 xl3 v-for="card in webJson" :key="card.id">
        <v-row justify="center">
          <v-snackbar v-model="snackbar" color="success" :timeout="timeout" top>
            {{ alertText }}
            <v-btn dark text @click="snackbar = false">
              Close
            </v-btn>
          </v-snackbar>
        </v-row>
        <v-card class="rounded">
          <v-responsive>
            <v-img :src="card.imgUrl" height="300px"> </v-img>
          </v-responsive>
          <v-card-title>
            <v-container fill-height fluid pa-2>
              <v-layout fill-height>
                <v-flex xs12 align-end flexbox>
                  <span class="font-regular caption" v-text="card.name"></span>
                  <v-divider></v-divider>
                  <span
                    class="font-regular caption"
                    v-if="$store.state.currency == 'INR'"
                  >
                    {{ $store.state.currencySymbol }} {{ card.INR }}</span
                  >
                  <span class="font-regular caption" v-else>
                    {{ $store.state.currencySymbol }} {{ card.USD }}</span
                  >
                  <v-divider></v-divider>
                  <span
                    class="font-regular caption"
                    v-text="card.technology"
                  ></span>
                  <v-divider></v-divider>
                  <span class="font-regular caption" v-text="card.tags"></span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-title>
          <v-card-actions>
            <v-flex v-if="card.type == 'website'">
              <v-btn
                color="primary"
                class="rounded"
                :to="{
                  name: 'web-template-details',
                  params: { web: card },
                  query: { wid: card.id, wname: card.name }
                }"
              >
                Explore
              </v-btn>
            </v-flex>
            <v-flex v-else>
              <v-btn
                color="primary"
                class="rounded"
                :to="{
                  name: 'ecommerce-template-details',
                  params: { web: card },
                  query: { wid: card.id, wname: card.name }
                }"
              >
                Explore
              </v-btn>
            </v-flex>
            <v-flex v-if="card.type == 'website'">
              <v-btn
                color="primary"
                class="rounded"
                :to="{
                  name: 'websiteform',
                  params: { web: card }
                }"
              >
                Place Order
              </v-btn>
            </v-flex>
            <v-flex v-else>
              <v-btn
                color="primary"
                class="rounded"
                :to="{
                  name: 'ecommerceform',
                  params: { web: card }
                }"
              >
                Place Order
              </v-btn>
            </v-flex>

            <v-flex>
              <v-btn color="error" icon @click="removeShortList(card.id)">
                <v-icon>
                  delete
                </v-icon>
              </v-btn>
            </v-flex>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { functions } from "../Firebase";
export default {
  name: "ShortList",
  data: () => ({
    snackbar: false,
    alertText: "",
    timeout: 10000,
    webJson: []
  }),
  props: {
    id: {
      type: String
    }
  },
  methods: {
    populate() {
      this.webJson = this.$store.state.shortList;
    },
    removeShortList(wid) {
      let i = this.$store.state.shortListId.indexOf(wid);
      let cid = this.$store.state.shortListDocId[i];
      this.$store.commit("removeShortList", i);
      this.$store.commit("removeShortListId", i);
      this.$store.commit("removeShortListDocId", i);
      var removeShortList = functions.httpsCallable("removeShortList");
      removeShortList({
        uid: this.$store.state.userId,
        id: cid
      }).then(() => {
        this.alertText = "Removed from BookMarks";
        this.snackbar = true;
      });
    }
  },
  mounted() {
    this.populate();
  }
};
</script>
